import { render, staticRenderFns } from "./HealthcareMatches.vue?vue&type=template&id=52fbfc3c&scoped=true&"
import script from "./HealthcareMatches.vue?vue&type=script&lang=js&"
export * from "./HealthcareMatches.vue?vue&type=script&lang=js&"
import style0 from "./HealthcareMatches.vue?vue&type=style&index=0&id=52fbfc3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fbfc3c",
  null
  
)

export default component.exports